import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { MenuItem } from '@mui/material';
import DropdownSelect from 'components/V2/DropdownSelect';
import { IS_SANDBOX_ENV } from 'helper/constant';
import PropTypes from 'prop-types';
import routeEndpoints from 'route/endpoints';

import { selectIsSetupGuideActive } from 'redux/selectors/general';

import styles from '../dashboard.module.css';

import { ReactComponent as LogoutIcon } from 'asset/IconsPack/at_log-out-03.svg';
import { ReactComponent as SettingsIcon } from 'asset/IconsPack/at_settings-01.svg';
import { ReactComponent as TicketIcon } from 'asset/IconsPack/at_ticket-01.svg';
import { ReactComponent as HelpIcon } from 'asset/icons/chat_icon.svg';

import SetupGuideModal from './SetupGuideModal';

function UserSettings({ firstName, handleHelpClick, nameInitials }) {
    const history = useHistory();
    const isSetupGuideActive = useSelector(selectIsSetupGuideActive);
    const [openSetupGuideModal, setOpenSetupGuideModal] = useState(false);

    const handleLogout = (closeMenu) => {
        closeMenu();
        history.push(routeEndpoints.logout);
    };

    const handleChatSupport = (closeMenu) => {
        closeMenu();
        handleHelpClick();
    };

    const handleSetupGuide = (closeMenu) => {
        closeMenu();
        setOpenSetupGuideModal(true);
    };

    const renderTrigger = () => (
        <>
            <span className={styles.nameInitials}>{nameInitials}</span> {firstName}
        </>
    );

    return (
        <>
            <DropdownSelect id="user-setting-menu" renderTrigger={renderTrigger}>
                {({ closeMenu, menuItemClass }) => (
                    <>
                        {!IS_SANDBOX_ENV && !isSetupGuideActive && (
                            <MenuItem
                                className={menuItemClass}
                                onClick={() => handleSetupGuide(closeMenu)}
                            >
                                <SettingsIcon className={styles.commonIconStyle} /> Setup Guide
                            </MenuItem>
                        )}
                        <MenuItem
                            className={menuItemClass}
                            onClick={() => handleChatSupport(closeMenu)}
                        >
                            <HelpIcon className={styles.commonIconStyle} /> Chat Support
                        </MenuItem>
                        <MenuItem
                            component="a"
                            href="https://info.authenticate.com/kb-tickets/new"
                            target="_blank"
                            rel="noreferrer"
                            className={menuItemClass}
                            onClick={closeMenu}
                        >
                            <TicketIcon className={styles.commonIconStyle} /> Raise a Support Ticket
                        </MenuItem>
                        <MenuItem className={menuItemClass} onClick={() => handleLogout(closeMenu)}>
                            <LogoutIcon className={styles.commonIconStyle} /> Logout
                        </MenuItem>
                    </>
                )}
            </DropdownSelect>
            <SetupGuideModal
                open={openSetupGuideModal}
                onClose={() => setOpenSetupGuideModal(false)}
            />
        </>
    );
}

UserSettings.propTypes = {
    firstName: PropTypes.string,
    handleHelpClick: PropTypes.func,
    nameInitials: PropTypes.string,
};

export default UserSettings;
